export const isDomElement = (domNode) => domNode?.nodeType === Node.ELEMENT_NODE;
